import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectProjeyiYaptiran, updateBaslikDefaults } from '../../../../redux/baslikSlice';

export default function ProjeyiYaptiranSection() {
  const dispatch = useDispatch();
  const data = useSelector(selectProjeyiYaptiran);

  const handleChange = (field, value) => {
    dispatch(updateBaslikDefaults({ section: 'projeyiYaptiran', changes: { [field]: value } }));
  };

  return (
    <div className="detail-section-content">
      <div className="detail-field">
        <label>Adi Soyadi</label>
        <input type="text" value={data.adiSoyadi} onChange={e => handleChange('adiSoyadi', e.target.value)} />
      </div>
      <div className="detail-field">
        <label>Adres (Mahalle)</label>
        <input type="text" value={data.adres} onChange={e => handleChange('adres', e.target.value)} />
      </div>
      <div className="detail-field">
        <label>Ilce / Il</label>
        <input type="text" value={data.ilceIl} onChange={e => handleChange('ilceIl', e.target.value)} />
      </div>
      <div className="detail-field">
        <label>Vergi Dairesi / No</label>
        <input type="text" value={data.vergiDairesiNo} onChange={e => handleChange('vergiDairesiNo', e.target.value)} />
      </div>
    </div>
  );
}
